module.exports = __webpack_public_path__ + "static/media/defaultThumbNail.0e638a5c.png";